import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { FocusOn } from "react-focus-on";
import cx from "classnames";
import { RCL as useTranslation } from "../RCL";
import * as styles from "./OktaHeader.module.scss";
import OktaMenu from "./OktaMenu";

const OktaHeaderSubMenu = ({
	isLoggedIn,
	isOktaMenuOpen,
	handleOktaSideMenuToggle,
	transitionState,
	handleTransition,
	locale,
	setLoginOpen,
	setWidgetAction,
	setOktaMenuToOpen,
	isAgent,
}) => {
	const menuRef = useRef(null);

	const dictionary = {
		"okta-header-side-menu-title": useTranslation({
			searchKey: "okta-header-side-menu-title",
		}),
		"a11y-close-menu": useTranslation({ searchKey: "a11y-close-menu" }),
	};

	useEffect(() => {
		if (transitionState) {
			setTimeout(() => {
				handleTransition();
			}, 200);
		}
	}, [handleTransition, transitionState]);

	const unmountTrap = () => {
		handleOktaSideMenuToggle(true);
		handleTransition();
	};

	return (
		<FocusOn
			enabled={isOktaMenuOpen}
			shouldIgnore={el => !(el.id === "gatsby-focus-wrapper" && el.tabIndex === -1)}
			onClickOutside={unmountTrap}
			onEscapeKey={unmountTrap}
			gapMode="padding">
			<div
				id="account-side-menu"
				ref={menuRef}
				className={cx(styles.headerMenuContainer, !isOktaMenuOpen ? styles.hidden : "")}
				aria-expanded={isOktaMenuOpen}>
				<div className={styles.headerMenuContainerHeader}>
					<p>{dictionary["okta-header-side-menu-title"]}</p>
					<button
						tabIndex={isOktaMenuOpen ? "0" : "-1"}
						type="button"
						aria-label={dictionary["a11y-close-menu"]}
						onClick={unmountTrap}>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="12.829"
							height="12.828"
							viewBox="0 0 12.829 12.828">
							<g id="Group_4646" data-name="Group 4646" transform="translate(1.413 1.414)">
								<g id="Group_1757" data-name="Group 1757" transform="translate(0)">
									<line
										id="Line_232"
										data-name="Line 232"
										x1="10"
										y2="10"
										transform="translate(0.001 0)"
										fill="none"
										stroke="#595959"
										strokeLinecap="round"
										strokeWidth="2"
									/>
									<line
										id="Line_233"
										data-name="Line 233"
										x2="10"
										y2="10"
										transform="translate(0.001 0)"
										fill="none"
										stroke="#595959"
										strokeLinecap="round"
										strokeWidth="2"
									/>
								</g>
							</g>
						</svg>
					</button>
				</div>

				<div className={cx(styles.menuAccountProfile, styles.sideMenu)}>
					<div ref={menuRef} className={styles.DropdownMenu}>
						<OktaMenu
							locale={locale}
							isUserLoggedIn={isLoggedIn}
							isOktaMenuOpen={isOktaMenuOpen}
							setLoginOpen={setLoginOpen}
							setWidgetAction={setWidgetAction}
							setOktaMenuToOpen={setOktaMenuToOpen}
							isAgent={isAgent}
						/>
					</div>
				</div>
			</div>
		</FocusOn>
	);
};

OktaHeaderSubMenu.propTypes = {
	isLoggedIn: PropTypes.bool.isRequired,
	isOktaMenuOpen: PropTypes.bool.isRequired,
	handleOktaSideMenuToggle: PropTypes.func.isRequired,
	transitionState: PropTypes.bool.isRequired,
	handleTransition: PropTypes.func.isRequired,
	locale: PropTypes.string.isRequired,
	setLoginOpen: PropTypes.func.isRequired,
	setWidgetAction: PropTypes.func.isRequired,
	setOktaMenuToOpen: PropTypes.func.isRequired,
	isAgent: PropTypes.bool,
};

OktaHeaderSubMenu.defaultProps = {
	isAgent: false,
};

export default OktaHeaderSubMenu;
